import { q } from '../../../shared/dom';
import { ctx2d, sizeCanvases } from './canvas';

interface Strip { x: number; y: number; r: number; h: number; vy: number; vx: number; rot: number; vr: number; coin: boolean; col: string; }

let parts: Strip[] = [];
let raf = 0;

/** Chuva de fitas e algumas moedas na camada da frente. O aguaceiro de ouro pesado vai atrás (#coins). */
export function confettiBurst(): void {
  const c = q<HTMLCanvasElement>('#confetti'), x = ctx2d(c);
  sizeCanvases();
  const strips = ['#FF6A00', '#00D66B', '#FFFFFF', '#FF9A3D'];
  parts = Array.from({ length: 150 }, () => {
    const coin = Math.random() < .26;
    return {
      x: Math.random() * c.width, y: -Math.random() * c.height * .5,
      r: (coin ? 7 + Math.random() * 9 : 5 + Math.random() * 7) * devicePixelRatio,
      h: (9 + Math.random() * 15) * devicePixelRatio,
      vy: (2.2 + Math.random() * 4.4) * devicePixelRatio,
      vx: (Math.random() - .5) * 2.6 * devicePixelRatio,
      rot: Math.random() * Math.PI, vr: (Math.random() - .5) * .3,
      coin, col: strips[Math.floor(Math.random() * strips.length)] as string
    };
  });
  cancelAnimationFrame(raf);
  (function loop() {
    x.clearRect(0, 0, c.width, c.height);
    let alive = 0;
    parts.forEach(p => {
      p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.vy += .045 * devicePixelRatio;
      if (p.y < c.height + 60) alive++;
      x.save(); x.translate(p.x, p.y);
      if (p.coin) {
        const w = Math.max(1, p.r * Math.abs(Math.cos(p.rot)));   // a moeda gira sobre o canto
        const g = x.createLinearGradient(-p.r, -p.r, p.r, p.r);
        g.addColorStop(0, '#FFF8DC'); g.addColorStop(.45, '#FFC93C'); g.addColorStop(1, '#A9761E');
        x.beginPath(); x.ellipse(0, 0, w, p.r, 0, 0, Math.PI * 2);
        x.fillStyle = g; x.fill();
        x.lineWidth = 1 * devicePixelRatio; x.strokeStyle = 'rgba(90,60,8,.65)'; x.stroke();
      } else {
        x.rotate(p.rot);
        x.fillStyle = p.col; x.fillRect(-p.r / 2, -p.h / 2, p.r, p.h);
      }
      x.restore();
    });
    if (alive) raf = requestAnimationFrame(loop); else x.clearRect(0, 0, c.width, c.height);
  })();
}
